$(function () {
    $('.twrap-top').each(function () {
        var $top = $(this);
        var $wrap = $top.next('.twrap');
        $top.find('.twrap-top__inner').width($wrap[0].scrollWidth);
        $top.on('scroll', function () { $wrap.scrollLeft($top.scrollLeft()); });
        $wrap.on('scroll', function () { $top.scrollLeft($wrap.scrollLeft()); });
    });
});

$.fn.inputSpinner = function (options) {
    options = $.extend(
        {
            step: 1,
            min: null,
            max: null,
            incrementClass: "btn btn-spinner",
            decrementClass: "btn btn-spinner"
        },
        options
    );

    return this.each(function () {
        var self = this;
        self.target = $(this);
        self.increment = null;
        self.decrement = null;

        if (self.target.is(":text") && !self.target.data("initialized")) {
            self.getValue = function () {
                return self.target.val();
            };

            self.setValue = function (value) {
                self.target.val(parseFloat(value));
            };

            self.init = function () {
                self.increment = $(
                    '<span class="' + options.incrementClass + '">+</span>'
                );
                self.decrement = $(
                    '<span class="' + options.decrementClass + '">-</span>'
                );
                self.target.before(self.decrement);
                self.target.after(self.increment);

                var css = {
                    "line-height": self.target.outerHeight() + "px",
                    height: self.target.outerHeight()
                };

                self.decrement.on("click", function () {
                    self.setValue(
                        parseFloat(self.getValue()) - parseFloat(options.step)
                    );
                    if (options.min && self.getValue() < options.min) {
                        self.setValue(options.min);
                    }
                    self.target.trigger("change");
                });

                self.increment.on("click", function () {
                    self.setValue(
                        parseFloat(self.getValue()) + parseFloat(options.step)
                    );
                    if (options.max && self.getValue() > options.max) {
                        self.setValue(options.max);
                    }
                    self.target.trigger("change");
                });

                self.target.data("initialized", true);
            };

            self.init();
        }
    });
};